<template>
    <div class="Element Back useHand" @click.prevent="handleBack">
        <div class="more-inline icon-only">
            <Icon name="arrow" />
        </div>
    </div>
</template>

<script>
import {defineComponent, inject } from "vue";
import { useRouter } from "vue-router";

import Icon from "components/icon";
import { contact, value, user_avatar } from "store/portal";
import trans from "helpers/_translation";
import { env } from "config";

export default defineComponent({
    name: "profile",
    props: {
    },
    components: {
        Icon,
    },
    setup() {

        const router = useRouter();
        // const handleClick = inject("handleClick");

        const handleBack = () => {
            // return handleClick('Dashboard profile');
            return router.go(-1);
        };

        return {
            env,
            value,
            user_avatar,
            contact,

            trans,
            handleBack
        };
    },
});
</script>